export default () => {

    jQuery(function($){
  
      const $fileWrap  = $('.wpcf7-form-control-wrap[data-name="your-file"]');
      const $fileInput = $fileWrap.find('input[type="file"]');
  
      if(!$fileInput.length) return;
  
      // Click wrapper
      $fileWrap.on('click', function(e){
        e.preventDefault();
        e.stopPropagation(); // ⭐ CHẶN LOOP
        $fileInput.trigger('click');
      });
  
      // Chặn bubbling khi click input
      $fileInput.on('click', function(e){
        e.stopPropagation();
      });
  
      // Khi chọn file
      $fileInput.on('change', function(){
  
        if(this.files.length){
  
          const fileName = this.files[0].name;
  
          $fileWrap
            .addClass('has-file')
            .attr('data-file', fileName);
  
        } else {
  
          $fileWrap
            .removeClass('has-file')
            .removeAttr('data-file');
  
        }
  
      });
  
    });
  
  };
  